// All ts arguments are ISO strings or ms timestamps. tz is an IANA timezone string.

export function formatDate(ts, tz) {
  return new Date(ts).toLocaleDateString("en-US", {
    timeZone: tz,
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatDateTime(ts, tz) {
  return new Date(ts).toLocaleString("en-US", {
    timeZone: tz,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatRelative(ts) {
  const diffMs = Date.now() - new Date(ts).getTime();
  const diffSec = Math.round(diffMs / 1000);
  if (diffSec < 60) return "just now";
  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `${diffMin} minute${diffMin !== 1 ? "s" : ""} ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `about ${diffHr} hour${diffHr !== 1 ? "s" : ""} ago`;
  const diffDay = Math.round(diffHr / 24);
  if (diffDay < 30) return `${diffDay} day${diffDay !== 1 ? "s" : ""} ago`;
  const diffMo = Math.round(diffDay / 30);
  if (diffMo < 12) return `${diffMo} month${diffMo !== 1 ? "s" : ""} ago`;
  return `${Math.round(diffMo / 12)} years ago`;
}

export function formatDateTimeWithRelative(ts, tz) {
  return `${formatDateTime(ts, tz)} · ${formatRelative(ts)}`;
}

export const STALE_THRESHOLD_MS = 5 * 60 * 1000;

export function isStale(lastSeen, now = Date.now()) {
  if (!lastSeen) return true;
  return now - new Date(lastSeen).getTime() > STALE_THRESHOLD_MS;
}

export function formatChartAxisLabel(val, tz, spanMs) {
  const d = new Date(val);
  const opts = { timeZone: tz };
  if (spanMs <= 2 * 3600_000) {
    return d.toLocaleTimeString("en-US", { ...opts, hour: "2-digit", minute: "2-digit" });
  }
  if (spanMs <= 7 * 86400_000) {
    return (
      d.toLocaleDateString("en-US", { ...opts, month: "short", day: "numeric" }) +
      " " +
      d.toLocaleTimeString("en-US", { ...opts, hour: "2-digit", minute: "2-digit" })
    );
  }
  return d.toLocaleDateString("en-US", { ...opts, month: "short", day: "numeric" });
}

export function formatChartTooltip(val, tz) {
  return new Date(val).toLocaleString("en-US", {
    timeZone: tz,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
